import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { constants } from './constants';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'Maxiplus';
  isShow = true;
  showModalCookie:boolean = false

  constructor(  private router: Router, 
                private localeService: BsLocaleService,
                private cookieService: CookieService,
              ) {
    //Se inicializa el idioma del datepicker
    esLocale.invalidDate = 'Fecha invalida';
    defineLocale('es', esLocale);
    this.localeService.use('es');
    router.events.subscribe((url: any) => this.validateShowComponents());

    this.showModalCookie = this.cookieService.get('Cookies técnicas') == "" 
    &&  this.cookieService.get('Cookies de funcionalidad') == ""
    &&  this.cookieService.get('Cookies de analítica y personalización') == ""
    &&  this.cookieService.get('Cookies para publicidad de terceros') == "" ;
  }
  
  validateShowComponents() {
    this.isShow = true;
    if(this.router.url.indexOf(constants.ROUTE_URL_ERROR_PAYMENT) !== -1 ||
      this.router.url.indexOf(constants.ROUTE_URL_OK_PAYMENT) !== -1){
      this.isShow = false;
    }

    if(this.router.url.indexOf(constants.ROUTE_URL_SUCCESS_PAYMENT_RECURRENT) !== -1 || 
       this.router.url.indexOf(constants.ROUTE_URL_ERROR_PAYMENT_RECURRENT) !== -1){
      this.isShow = true;
    }
   
  }

}
